import { createFileRoute } from '@tanstack/react-router'

import { ReportClaimPage } from '../../../../components/pages/report-claim/report-claim-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/report-claim')({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <ReportClaimPage />
    </PermissionChecker>
  ),
})
